export enum Color {
  Green = "green",
  LightGreen = "light-green",
  MintGreen = "mint-green",
  Orange = "orange",
  Yellow = "yellow",
  Blue = "blue",
  LightBlue = "light-blue",
  Black = "black",
  Charcoal = "charcoal",
  Coal = "coal",
  Gray = "gray",
  LightGray = "light-gray",
  Cream = "cream",
  Pink = "pink",
  White = "white",
  PayflexPurple = "payflex-purple",
  PayflexNavy = "payflex-navy",
  IndustryPink = "industry-pink",
}
